package tech.gensert.portal.web.routes

import ErrorPage
import js.core.jso
import kotlinx.browser.window
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.router.dom.createBrowserRouter
import react.router.useNavigate
import react.useState
import remix.run.router.LoaderFunction
import tech.gensert.portal.web.pages.LandingPageShowcase
import tech.gensert.portal.web.pages.LogoutPage
import tech.gensert.portal.web.pages.Page
import tech.gensert.portal.web.showcase.PaymentAndSubscriptionShowcase
import tech.gensert.portal.web.showcase.ServicesCard
import tech.gensert.portal.web.showcase.SettingsShowcase
import tech.gensert.portal.web.showcase.utils.useTokenManager
import kotlin.js.Promise

val LoaderComponent: FC<Props> = FC {
    div {
        +"Loading..."
    }
}
val MATERIAL_SHOWCASES: Array<out Showcase> = arrayOf(
    Showcase("services", "Services", ServicesCard),
    Showcase("subscriptions", "Subscriptions", PaymentAndSubscriptionShowcase),
    Showcase("settings", "Settings", SettingsShowcase),
)
val ShowcaseMaterialLoader: LoaderFunction = { args ->
    val showcaseId = args.params["showcaseId"]
    val showcase = MATERIAL_SHOWCASES.find { it.key == showcaseId }
    Promise.resolve(showcase ?: throw IllegalArgumentException("Showcase not found for ID: $showcaseId"))
}

external interface ProtectedRouteProps : Props {
    var component: FC<Props>
}

val ProtectedRoute: FC<ProtectedRouteProps> = FC { props ->
    val navigate = useNavigate()
    val (tokenManager, msalReady) = useTokenManager()
    val (isCheckingAuth, setIsCheckingAuth) = useState(true)

    react.useEffectOnce {
        window.setTimeout({
            if (!tokenManager.isAuthenticated()) {
                if (!msalReady) {
                    navigate("/")
                }
                tokenManager.getToken(
                    { setIsCheckingAuth(false) },
                    { navigate("/") }
                )
            } else {
                setIsCheckingAuth(false)
                val currentPath = window.location.pathname
                if (currentPath == "/") {
                    navigate("/services")
                }
            }
        }, 500)
    }
    if (isCheckingAuth || !msalReady) {
        return@FC LoaderComponent()
    }
    props.component()
}
val ProtectedServices: FC<Props> = FC {
    ProtectedRoute {
        component = ServicesCard
    }
}
val ProtectedShowcase: FC<Props> = FC {
    ProtectedRoute {
        component = ShowcaseMaterial
    }
}
val PageLoader: LoaderFunction = { _ ->
    Promise.resolve(MATERIAL_SHOWCASES)
}
val appRouter = createBrowserRouter(
    arrayOf(
        jso {
            path = "/"
            loader = PageLoader
            Component = LandingPageShowcase
            ErrorBoundary = ErrorPage
        },

        jso {
            path = "/"
            loader = PageLoader
            Component = Page
            ErrorBoundary = ErrorPage
            children = arrayOf(
                jso {
                    index = true
                    path = "services"
                    loader = PageLoader
                    Component = ProtectedServices
                    ErrorBoundary = ErrorPage
                },
                jso {
                    path = ":showcaseId"
                    loader = ShowcaseMaterialLoader
                    Component = ProtectedShowcase
                    ErrorBoundary = ErrorPage
                },
                jso {
                    path = "/logout"
                    Component = LogoutPage
                    ErrorBoundary = ErrorPage
                },
                jso {
                    path = "*"
                    Component = ErrorPage
                }

            )
        }
    )
)